<div class="discount-details">
  <mat-spinner diameter="16" *ngIf="loading"></mat-spinner>
  <span *ngIf="error" class="error">{{ error }}</span>

  <div *ngIf="coupon" class="coupon-container text__small">
    <span class="strong">{{ coupon.name }}</span>
    / Get
    <ng-container *ngIf="coupon.discount_percentage">{{ coupon.discount_percentage }}%</ng-container>
    <ng-container *ngIf="coupon.discount_amount">{{ coupon.discount_amount_formatted }}</ng-container>
    off for
    <ng-container [ngSwitch]="coupon.duration_type">
      <ng-container *ngSwitchCase="'forever'">forever</ng-container>
      <ng-container *ngSwitchCase="'one_time'">your first bill</ng-container>
      <ng-container *ngSwitchCase="'limited_period'">
        the first {{ coupon.period }} {{ coupon.period_unit }}s
      </ng-container>
    </ng-container>
  </div>
</div>
